'use client'

import { useEffect } from 'react'

export const ScrollToHash = ({ hash }: { hash: string }) => {
	useEffect(() => {
		if (window.location.hash !== hash) return

		const frame = requestAnimationFrame(() => {
			document.querySelector(hash)?.scrollIntoView()
		})

		return () => cancelAnimationFrame(frame)
	}, [hash])

	return null
}
